import React from "react";

export const Research = (props) => {
  return (
    <div id="research" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2>Research</h2>
        </div>
        <br></br>
        <div className="col-md-8 col-md-offset-2 text-justify-xs">
          <div className="research-text">
            <h3>Primary Interests</h3>
            <p>Programming languages</p>
            <p>Acoustics</p>
            <p>Geographic Information Systems</p>
            <br></br>
            <h3>Selected Papers</h3>
            <p>
              M. Sikora, J. Đerek, M. Pauković, A. Jurčević{" "}
              <a href="https://www.researchgate.net/publication/362068927_Acoustics_of_Roman_theatre_of_Salona">
                Acoustics of Roman theatre of Salona
              </a>{" "}
              <b>2nd Symposium: The Acoustics of Ancient Theatres</b>, 6-8 July
              2022 Verona, Italy
            </p>
            <p>
              J. Đerek, M. Sikora. L. Kraljević, M. Russo{" "}
              <a href="https://www.mdpi.com/2076-3417/11/21/10065">
                Using Neural Networks for Bicycle Route Planning
              </a>{" "}
              <b>Applied Sciences-Basel</b>, Vol. 1, pp. 100651, 2021.
            </p>
            <p>
              L. Kraljevic, M. Russo, M. Stella, M. Sikora{" "}
              <a href="https://ieeexplore.ieee.org/document/9089013">
                Free-Field TDOA-AOA Sound Source Localization Using Three
                Soundfield Microphones
              </a>{" "}
              <b>IEEE access</b>, Vol. 8, pp. 87749-87761, 2020.
            </p>
            <p>
              M. Sikora, M. Russo, J. Đerek, A. Jurčević{" "}
              <a href="https://dl.acm.org/citation.cfm?id=3230652">
                Soundscape of an Archaeological Site Recreated with Audio
                Augmented Reality
              </a>{" "}
              <b>
                ACM Transactions on Multimedia Computing, Communications, and
                Applications
              </b>
              , Vol. 14, No. 3, Article 74 (22 pages), 2018.
            </p>
            <p>
              M. Sikora, H. Mihanović, I. Vilibić{" "}
              <a href="papers/ACTA_ADRIATICA_14.pdf">
                Paleo-coastline of the Central Eastern Adriatic Sea, and
                paleo-channels of the Cetina and Neretva rivers during the last
                glacial maximum
              </a>{" "}
              <b>Acta Adriatica</b>, Vol. 54, No. 1, pp. 3-18, 2014.
            </p>
            <p>
              M.Sikora, I. Mateljan{" "}
              <a href="papers/ENGINEERING_WITH_COMPUTERS_13.pdf">
                A Method for Speeding up Beam-tracing Simulation Using
                Thread-level Parallelization
              </a>{" "}
              <b>Engineering with Computers</b>, Vol. 30, No. 4, pp. 679-688,
              2014.
            </p>
            <p>
              M.Sikora, I. Mateljan, N. Bogunović{" "}
              <a href="papers/AUTOMATIKA_11.pdf">
                Beam Division in Acoustic Simulation of Non-Homogenous
                Environments
              </a>{" "}
              <b>Automatika</b>, Vol. 52, No. 4, pp. 339-352, 2011.
            </p>
            <br />
            <h3>Theses</h3>
            <p>
              <b>Ph.D.</b> -{" "}
              <a href="papers/PH_D_10.pdf">
                {" "}
                Simulation and visualization methods for wave propagation in
                non-homogenous media
              </a>
              , Faculty of Electrical Engineering and Computing, University of
              Zagreb, 2010.
            </p>
            <p>
              <b>M.Sc.</b> -{" "}
              <a href="papers/M_SC_01.pdf">
                3D simulation of ultrasound field inside the human scull
              </a>
              , Faculty of Electrical Engineering and Computing, University of
              Zagreb, 2001.
            </p>
            <br></br>
            <br></br>{" "}
            <p>
              <b>
                <a href="https://www.croris.hr/crosbi/searchByContext/2/3048">
                  Complete list of all publications can be found here.
                </a>
              </b>
            </p>
            <br></br>
            <h3>Projects</h3>
            <p>
              2021-2023:{" "}
              <a href="https://vita.fesb.unist.hr/">
                VITA: Virtual telemedicine assistant
              </a>{" "}
              (researcher)
            </p>
            <p>
              2015-2018:{" "}
              <a href="https://www.fesb.unist.hr/znanost/istrazivanje-naprednih-tehnologija-za-pametne-okoline/">
                ELISE: Easy Living in Smart Environments
              </a>{" "}
              (researcher)
            </p>
            <p>
              2007-2011:{" "}
              <a href="https://www.croris.hr/projekti/projekt/1178">
                Analysis and synthesis of ultrasound field for application on
                tissue
              </a>{" "}
              (researcher)
            </p>
            <p>
              2002-2004:{" "}
              <a href="http://zprojekti.mzos.hr/zprojektiold/prikaz_det.asp?offset=271&ID=0036023">
                {" "}
                Effect of high-energy ultrasound on tissue
              </a>{" "}
              (researcher)
            </p>
            <p>
              1996-2002:{" "}
              <a href="http://zprojekti.mzos.hr/zProjektiOld/arh_det.asp?offset=390&ID=394">
                {" "}
                Effect of ultrasound cavitation on neural tissue{" "}
              </a>{" "}
              (consultant)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
